/* Desktop prev/next arrows for the product media gallery (Figma E2 design).
   ponytail: piggybacks on the theme's thumbnail buttons — clicking an arrow
   clicks the adjacent thumbnail, so all media-switching logic stays in
   media-gallery.js. If the gallery ever drops thumbnails, these arrows need
   their own setActiveMedia wiring. */
if (!customElements.get('gallery-arrows')) {
  customElements.define(
    'gallery-arrows',
    class GalleryArrows extends HTMLElement {
      connectedCallback() {
        this.gallery = this.closest('media-gallery');
        if (!this.gallery) return;
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.addEventListener('click', this.onClick.bind(this));
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.gallery, {
          attributes: true,
          subtree: true,
          attributeFilter: ['aria-current'],
        });
        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      thumbnails() {
        return Array.from(this.gallery.querySelectorAll('.thumbnail-list__item .thumbnail')).filter((thumb) => {
          const item = thumb.closest('.thumbnail-list__item');
          return item && item.offsetParent !== null;
        });
      }

      activeIndex(thumbs) {
        return thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true');
      }

      onClick(event) {
        const button = event.target.closest('button[name]');
        if (!button || button.disabled) return;
        const thumbs = this.thumbnails();
        if (!thumbs.length) return;
        const current = this.activeIndex(thumbs);
        const target = button.name === 'next' ? current + 1 : current - 1;
        if (target < 0 || target >= thumbs.length) return;
        thumbs[target].click();
        this.update();
      }

      update() {
        const thumbs = this.thumbnails();
        const current = this.activeIndex(thumbs);
        if (this.prevButton) this.prevButton.disabled = current <= 0;
        if (this.nextButton) this.nextButton.disabled = current === -1 || current >= thumbs.length - 1;
      }
    }
  );
}
